import { AppBundle } from 'api/optimalprint-sdk.d';

const getFilterValue = (
  typeName: string,
  filters: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters | undefined,
  defaultValue: any,
  singleValue = false,
) => {
  const result: string[] = [];
  if (filters) {
    [...filters.attributeFilters, ...filters.tagFilters].some((filter) => {
      if (filter.typeName === typeName) {
        if (filter.options) {
          const selectedOptions = filter.options?.filter((option) => option.isSelected);
          if (selectedOptions.length) result.push(...selectedOptions.map((option) => option.value));
        }
        return true;
      }
      return false;
    });
  }
  if (!result.length) return defaultValue;

  return singleValue ? result[0] : result;
};

export default getFilterValue;
